import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    async download(eventOrElement) {
        // 1. Check if it's an event (has preventDefault) or an element
        const isEvent = eventOrElement.preventDefault !== undefined

        if (isEvent) {
            eventOrElement.preventDefault()
        }

        // 2. Get the element (either currentTarget from event, or the element itself)
        const element = isEvent ? eventOrElement.currentTarget : eventOrElement

        const url = element.dataset.url
        const filename = element.dataset.filename || 'download'

        try {
            const response = await fetch(url, {
                mode: 'cors',
                headers: {
                    'Origin': window.location.origin
                }
            })

            if (!response.ok) throw new Error('Network response was not ok')

            const blob = await response.blob()
            const blobUrl = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = blobUrl
            link.download = filename
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            window.URL.revokeObjectURL(blobUrl)
        } catch (error) {
            console.warn("CORS fetch failed, falling back to window.open", error)
            const link = document.createElement('a')
            link.href = url
            link.target = '_blank'
            link.download = filename
            link.click()
        }
    }

    downloadAll(event) {
        event.preventDefault()
        const buttons = this.element.querySelectorAll('[data-filename*="echoage-insta"], [data-filename*="echoage-fb"]')

        buttons.forEach((btn, index) => {
            setTimeout(() => {
                // Now passing the element safely
                this.download(btn)
            }, index * 200)
        })
    }
}